import { render } from "./ThemeContentsTab.vue?vue&type=template&id=a11cb836"
import script from "./ThemeContentsTab.vue?vue&type=script&lang=js"
export * from "./ThemeContentsTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__